export const AVAILABILITY_OPTIONS = [
  'Jam Sessions',
  'Starting a Band',
  'Studio Sessions',
];

export const toggleAvailabilitySelection = (
  selected: string[],
  availability: string,
  max: number
): string[] => {
  const normalized = Array.isArray(selected) ? selected : [];
  if (normalized.includes(availability)) {
    return normalized.filter((item) => item !== availability);
  }
  if (normalized.length >= max) {
    return normalized;
  }
  return [...normalized, availability];
};
